export enum ReviewScoreScale {
    Excellent = 'excellent',
    VeryGood = 'very-good',
    Good = 'good',
    Fair = 'fair',
    Poor = 'poor',
    Bad = 'bad',
    VeryBad = 'very-bad',
}
